import React, {ReactElement} from 'react';
import {ProvisionedAppConfig} from "../shared/types";
import "../res/css/App.css";
import {PathComponent} from "../index";
import {PeppinApp} from "../peppin-shared/PeppinApp";
import {Main} from "./Main";

export class App extends PeppinApp {

  protected getAppName(): string {
    return "Choreographer";
  }

  getProvisionedAppId(): string {
    return "choreographer";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return null;
  }

  static nestedPaths(): PathComponent[] {
    return [];
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
